import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/Header.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/link.js");
